import React, { useEffect,useState } from "react";
import { observer } from "mobx-react";
import {useDropzone} from 'react-dropzone';
import {  IconUpload} from "TemplateCerere";
import { convertBytesToMbsOrKbs, getFileType } from "Utils";
import "./dropZoneArea.scss"

function DropZoneArea(props) {
  const {acceptedFiles, filesLimit, maxFileSize, onDrop,openError, errors} = props
  const [acceptedFileType, setAcceptedFileType] = useState();
  
  //compun lista de fisiere acceptate    
  useEffect(() => {
    var fileType={};
      acceptedFiles.forEach(e => {
        var eType = getFileType(e.replace('.',''));
        var eList = fileType[eType]??[];
        if (eType){
          eList.push(e);
          fileType[eType]= eList;
        }
    });
    setAcceptedFileType(fileType);
  },[])


  const {  getRootProps, getInputProps} = useDropzone( {
      maxFiles: filesLimit,
      accept: acceptedFileType,
      maxSize: maxFileSize,
      multiple: filesLimit > 1 ,
      onDropRejected:(rejectedFiles)=>{
        const err = rejectedFiles.flatMap((f)=>{
          return f.errors.flatMap(e=>{
            if(e.code=="file-invalid-type") 
              return( errors.acceptedFiles ||"Acest tip de fisier nu este suportat. ");
            if(e.code=="file-too-large") 
              return(errors.maxFileSize ||"Fisierul este prea mare. Marimea maxima admisa este " + convertBytesToMbsOrKbs(maxFileSize) +". ");
            if(e.code=="too-many-files") 
               return(errors.filesLimit ||"Numarul maxim de fisiere permise este depasit. Numarul de fisiere permise este ".concat(filesLimit,"."));
            //daca nu este tratata eroarea
            return (errors.rejectedFile ||"Fisierul ".concat(f.file.name, " este respins. "));
            });

        })
        openError(err);
      },
      onDropAccepted: onDrop
  }
     );

  return (
    <div className="image-drop">
      <div {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()} />
        
                <IconUpload className="icon-upload" />
                <div className="image-text">Click pentru a incarca un fisier</div>
                <div className="image-text-note">
                  (Poti incarca un fisier inclusiv prin "drag and drop")
                </div>
              </div>
    </div>
  );
}

export default observer(DropZoneArea);
